<template>
  <div>
    <base-header class="pb-6 bg-light">
      <b-row aling-v="center" class="py-4">
        <b-col cols="7" lg="6">
          <h6 class="h2 d-inline-block mb-0 text-dark">Server Statistics</h6>
        </b-col>
        <b-col cols="5" lg="6" class="text-right">
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </b-col>
      </b-row>

    </base-header>

    <b-container fluid class="mt--6">
      <b-card no-body>
        <span class="h1 text-dark mt-4 ml-3 text-center">Details</span>

        <div class="text-center w-100">
          <b-icon icon="three-dots"
                  class="text-center" animation="cylon"
                  font-scale="4"
                  v-if="loadingStatus"></b-icon>
        </div>
        <!--            :fields="tableColumns"-->

        <div class="d-flex" v-if="!loadingStatus">
          <span class="responsive-table">
            <div v-highlight class="overflow-auto w-auto h-auto">
              <pre><code class="json">{{
                  fJson(this.tableData)
                }}</code></pre>
            </div>
          </span>
        </div>


        <!--        <b-table-->
        <!--            v-if="!loadingStatus"-->
        <!--            striped hover-->
        <!--            :items="tableData"-->
        <!--            :filter="filter"-->
        <!--            head-variant="light"-->
        <!--            class="customer-table"-->
        <!--            show-empty-->
        <!--            responsive-->
        <!--            small-->
        <!--          >-->
        <!--          </b-table>-->
      </b-card>
    </b-container>
  </div>
</template>

<script>
import homeDashboardService from "@/common/api-services/home-dashboard-service";
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
import coreutils from "@/common/coreutils";
//import {default as prettyHtml} from "json-pretty-html";

export default {
  name: "Server-Statistics",
  components: {
    RouteBreadCrumb,
  },
  data() {
    return {
      loadingStatus: false,
      totalRows: 0,
      currentPage: 1,
      pageOptions: [10, 25, 50, 100],
      perPage: 10,
      // tableColumns: [
      //   {key: 'actiondate', label: 'Date', sortable: true, sortDirection: 'desc'},
      //   {key: 'method', label: 'Action', sortable: true, sortDirection: 'desc'},
      //   {key: 'user', label: 'User', sortable: true, sortDirection: 'desc'},
      //   {key: 'fault', label: 'Error', sortable: true, sortDirection: 'desc'},
      //   {
      //     key: 'response', label: 'Message', sortable: true, sortDirection: 'desc',
      //     // formatter: (value, key, item) => {
      //     //   let res = value;
      //     //   try {
      //     //     res = JSON.parse(res);
      //     //     res = commonService.parseJsonToHtml(res);
      //     //   } catch (e) {
      //     //     console.error(e,res)
      //     //   }
      //     //   return res
      //     // },
      //   },
      // ],
      tableData: [],
      localData: [],
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      startPage: 1,
      fromPage: 10,
      lastPage: 1,
      submitLoading: false,
    }
  },
  mounted() {
    document.title = 'Server-Statistics';
    this.getServerStatus();
  },
  methods: {

    fJson(text) {
      return coreutils.formatJson(text);
    },

    // formatJson(jsonData){
    //   var prettyHtml = require('json-pretty-html').default;
    //   var htmlTable = prettyHtml(jsonData);
    //   //remove the curley brackets and backslash
    //   let html = htmlTable.toString();
    //   return html;
    // },

    //https://bootstrap-vue.org/docs/components/table
    getServerStatus() {
      this.loadingStatus = true;
      this.submitLoading = true
      this.tableData = [];
      homeDashboardService.getServerStatus().then(res => {
        //console.log('data:',res)
        this.loadingStatus = false;
        this.submitLoading = false;
        if (res) {
          if (res.includes('FAIL')) {
            this.$toast.error(res)
          } else if (res !== 'No data found' && !res.includes('Error')) {
            this.tableData = res;
            this.totalRows = res.length;
          }
        } else {
          this.$toast.error("Server can't response !")
        }
      });
    },

  }
}
</script>
